import React, { useState } from 'react';
import { Chart } from 'primereact/chart';
import classNames from 'classnames';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import AddNewUserDialog from './AddNewUserDialog';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
    const [showDialog , setShowDialog]= useState(false)
    const [basicData] = useState({
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [
            {
                label: 'Items Sold',
                backgroundColor: '#49464d',
                data: [65, 59, 80, 81, 56, 55, 40, 33, 25, 69, 87 ,20]
            },
            {
                label: 'Revenue Generated',
                backgroundColor: '#f8a91b',
                data: [28, 48, 40, 19, 86, 27, 90, 33, 25, 69, 87 , 50]
            }
        ]
    });
    const navigate= useNavigate()

    const basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            },
            tooltips: {
                mode: 'index',
                intersect: true
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                    color: '#ebedef'
                },
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                }
            }
        }
    };
    const storeName = localStorage.getItem('storeName')

    const handleAddDialog = () => {
        setShowDialog(true)
    }
    const onHideDialog = () => {
        setShowDialog(false)
    }

    const userRole = localStorage.getItem('roleId');
    

    return (
        <>
            <div className="card Card__Round flex align-item-center">
                <h4 className="mt-2">Welcome {storeName}</h4>
                {userRole === 1 || (userRole === '1' && <Button label="Add New Store" className="Btn__Add__ ml-auto mt-0 mb-0" onClick={() => navigate('/addnewuser')} />)}
            </div>
            <div className="card">
                <h5>Shopify Stats</h5>
                <Chart type="bar" data={basicData} options={basicOptions} />
            </div>
        </>
    );
};

export default Dashboard;
